import { createEmptySliceBase, injectDetailSlice, toReducer } from '../sliceFactory';

const createOfficePriceListsReducer = () => {
  const base = createEmptySliceBase({ name: 'officePriceLists' });
  const withDetail = injectDetailSlice({ sliceBase: base });
  return toReducer(withDetail);
};

export default createOfficePriceListsReducer;
